import MatsManagementApp from "./MatsManagementApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(MatsManagementApp);
